var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#24292D",
    d: "m10.164 5.346-.958.958-.959-.959a3.842 3.842 0 0 0-5.434 5.434l1.356 1.357 4.648 4.444c.218.208.56.208.778 0l4.64-4.435 1.364-1.366a3.84 3.84 0 0 0 0-5.433 3.84 3.84 0 0 0-5.435 0zm-5.209 5.986L3.61 9.984a2.716 2.716 0 0 1 0-3.843 2.713 2.713 0 0 1 3.842 0L8.81 7.497c.22.22.575.22.795 0L10.96 6.14a2.714 2.714 0 0 1 3.843 0 2.716 2.716 0 0 1 0 3.843l-1.355 1.357-4.242 4.054-4.25-4.063z"
  })));
};
export default SvgHeart;